import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InstagramApiService, InstagramAccount } from 'src/app/services/instagram.service';

@Component({
  selector: 'app-instagram-accounts',
  templateUrl: './instagram-accounts.component.html',
  styleUrls: ['./instagram-accounts.component.scss']
})
export class InstagramAccountsComponent implements OnInit {
  storeId!: number;
  accounts: InstagramAccount[] = [];
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private instaApi: InstagramApiService
  ) {}

  ngOnInit(): void {
    this.storeId = Number(this.route.snapshot.paramMap.get('store'));
    this.fetchAccounts();
  }

  fetchAccounts(): void {
    this.loading = true;
    this.instaApi.listAccounts(this.storeId).subscribe({
      next: res => {
        this.accounts = res.accounts;
        this.loading = false;
      },
      error: () => this.loading = false
    });
  }

  remove(account: InstagramAccount): void {
    if (!confirm(`Remover conta ${account.instagram_user_id}? Isso invalidará o token.`)) {
      return;
    }
    this.instaApi.deleteAccount(this.storeId, account.id).subscribe({
      next: () => this.fetchAccounts(),
      error: () => alert('Falha ao remover')
    });
  }
}
